export class DistributeAndCommissionDictionary{
    static PERMIT_DISTRIBUTE_NOT=0; //不能分销
    static PERMIT_DISTRIBUTE_YES=1;  //可以分销
    static PERMIT_DISTRIBUTE_AUDITING=10;  //分销审核中
    
    static COMMISSION_LEVEL0=0;//经销商佣金
    static COMMISSION_LEVEL1=1;//一级佣金
    static COMMISSION_LEVEL2=2;//二级佣金

    static COMMISSION_NOT_CREDITED=0;//佣金未到帐
    static COMMISSION_CREDITED=1;//佣金已到帐
}

export class DistributeAndCommissionSource{
    static COMMISSION_LEVEL_MAP={
        [DistributeAndCommissionDictionary.COMMISSION_LEVEL0]:"经销商佣金",
        [DistributeAndCommissionDictionary.COMMISSION_LEVEL1]:"一级佣金",
        [DistributeAndCommissionDictionary.COMMISSION_LEVEL2]:"二级佣金"
    };
    static COMMISSION_LEVEL_SOURCE=[
        {value:DistributeAndCommissionDictionary.COMMISSION_LEVEL0,text:"经销商佣金"},
        {value:DistributeAndCommissionDictionary.COMMISSION_LEVEL1,text:"一级佣金"},
        {value:DistributeAndCommissionDictionary.COMMISSION_LEVEL2,text:"二级佣金"}
    ];
    static COMMISSION_STATUS_SOURCE=[
        {value:DistributeAndCommissionDictionary.COMMISSION_NOT_CREDITED,text:"未到账"},
        {value:DistributeAndCommissionDictionary.COMMISSION_CREDITED,text:"已到账"}
    ]
}